import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/price-to-book-calculator',
  component: () => import('../../routes/PriceToBookCalculator.svelte'),
  card: {
    id: 'price-to-book-calculator',
    title: 'Price-to-Book (P/B) Ratio',
    description: 'Calculate P/B ratio to evaluate whether a stock is overvalued or undervalued relative to its book equity.',
    icon: 'balance',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/price-to-book-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Price-to-Book (P/B) Ratio Calculator – Free P/B Calculator',
    description: 'Calculate the Price-to-Book (P/B) ratio to evaluate whether a stock is overvalued or undervalued relative to its book equity. Supports market cap and share-price modes.',
  },
};

export default meta;